export default {
      id: "ic-nav-chevron-right-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }